import { useRef } from 'react'

import { debounce, isFunction } from 'lodash'

const useDebounce = (func, delay) => {
  const debouncer = useRef(null)

  const call = (...params) => {
    if (debouncer.current) {
      debouncer.current.cancel()
    }

    if (isFunction(func)) {
      debouncer.current = debounce(() => func(...params), delay)
      debouncer.current()
    }
  }

  return call
}

export default useDebounce
